export default __webpack_public_path__ + "static/media/panTech4Full.7e085e94.png";